/**
 * 이미지 모듈 테마. 값은 서버 IMAGE_MODULE_THEMES, 공개 페이지 imageThemes.js 와 같아야 한다.
 * 여기 색은 선택 카드 미리보기용 (실제 화면은 공개 페이지 쪽 정의).
 */
export const IMAGE_MODULE_THEMES = [
    { value: 'BASIC', label: '기본', paper: '#ffffff', tape: null, line: '#e5e7eb' },
    { value: 'CREAM', label: '크림', paper: '#fffaf0', tape: '#f4dca8', line: '#eadcc2' },
    { value: 'PINK', label: '벚꽃', paper: '#fff4f6', tape: '#f7c3cf', line: '#f3d3da' },
    { value: 'SKY', label: '하늘', paper: '#f2f8ff', tape: '#b9d7f5', line: '#d3e3f3' },
    { value: 'MINT', label: '민트', paper: '#f1fbf6', tape: '#b5e3cb', line: '#cfe9dc' },
    { value: 'LAVENDER', label: '라벤더', paper: '#f7f3ff', tape: '#d4c5f5', line: '#e2d9f5' },
    { value: 'NIGHT', label: '밤하늘', paper: '#232838', tape: '#8f86c9', line: '#3a4056' },
];

/** 예전 문서(displayConfig 없음): 설명이 있으면 표시 + 크림, 없으면 기본 */
export function resolveDisplayConfig(item) {
    return item?.displayConfig || { showDescription: !!item?.description, theme: item?.description ? 'CREAM' : 'BASIC' };
}
